// useFramework.js
import { useState, useEffect, useRef } from "react";

export const useLesson = () => {
  // Framework variables
  const [variable1, setVariable1] = useState("Initial Value 1");
  const [variable2, setVariable2] = useState("Initial Value 2");
  const mainRef = useRef(null);
  const [lessonCode, setLessonCode] = useState(`public class HelloWorld {
    public static void main(String[] args) {
        System.out.println("Hello, World!");
    }
}`);

  // Framework methods
  const method1 = () => `Method1 says: ${variable1}`;
  const method2 = () => `Method2 uses: ${variable2}`;

  //sets the inial code of the lesson
  function setInitialCode(newCode) {
    setLessonCode(newCode);
  }

  // Side effects (e.g., fetch data, initialize variables, etc.)
  useEffect(() => {
    setVariable1("Updated Value 1");
    setVariable2("Updated Value 2");

    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainRef.current) {
      mainRef.current.scrollTop = 0;
    }
  }, []); // Runs once on mount

  return { lessonCode, variable2, method1, method2, setInitialCode };
};
